module.exports = __webpack_public_path__ + "static/media/instagram-icon.5b3a33ed.svg";